import { render, staticRenderFns } from "./DadosDdd.vue?vue&type=template&id=74661ef0&"
import script from "./DadosDdd.vue?vue&type=script&lang=ts&"
export * from "./DadosDdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports